<script>
    export let value;
</script>

<h3>3. Wanneer wil je notificaties ontvangen?</h3>
<ul>
    <li>
        <label>
            <input type="radio" name="notification_interval" bind:group={value} value='no'>
            <b>Geen</b> - ik wil geen notificaties ontvangen voor dit dossier
        </label>
    </li>
    <li>
        <label>
            <input type="radio" name="notification_interval" bind:group={value} value='direct'>
            <b>Direct</b> - Stel mij meteen op de hoogte als er een nieuw document is
        </label>
    </li>
    <li>
        <label>
            <input type="radio" name="notification_interval" bind:group={value} value='daily'>
            <b>Dagelijks</b> - Ontvang dagelijks een overzicht van nieuwe documenten
        </label>
    </li>
    <li>
        <label>
            <input type="radio" name="notification_interval" bind:group={value} value='weekly'>
            <b>Wekelijks</b> - Ontvang wekelijks een overzicht van nieuwe documenten
        </label>
    </li>
</ul>

<style lang="scss">
    h3 {
        margin-bottom: 20px;
        font-size: 24px !important;
        line-height: 24px;
    }

    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        color: var(--dark-blue-color);

        li {
            margin-bottom: 15px;
            line-height: 20.8px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>
